export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.fullPath.includes('/es/legal')) {
    const router = useRouter()
    const redirectToPath = router.getUrlByKey({ key: to.meta[0].key }, 'en')
    return navigateTo(redirectToPath)
  }
})
